angular.module('gym.calendar').controller('RescheduleFutureEventsCtrl', ["$scope", "$modalInstance", "flash", "ConfirmLeaveUnsavedChangesService", "params", function($scope, $modalInstance, flash, ConfirmLeaveUnsavedChangesService, params) {
  var dateTimeToDate, dateToTime, mergeDateAndTime;
  $scope.event = params.event;
  $scope.isDateChangeInValidForMonthlyRecurring = $scope.event.repeat_interval_unit === 'month' && $scope.event.monthly_repeat_rule !== 'repeat_on_nth_day_of_month';
  $scope.isWeekly = function() {
    return $scope.event.repeat_interval_unit === 'week';
  };
  $scope.frequencyUpdateParams = {
    change_type: 'reschedule_future_events',
    change_attributes: {}
  };
  dateTimeToDate = function(dt) {
    return moment(dt, 'YYYY/MM/DD HH:mm').toDate();
  };
  dateToTime = function(d) {
    return moment(d).format('HH:mm:ss');
  };
  mergeDateAndTime = function(d, t) {
    return `${d} ${dateToTime(t)}`;
  };
  $scope.formData = {
    reschedule_date: $scope.event.event_date,
    new_start_at: dateTimeToDate($scope.event.start_at),
    new_end_at: dateTimeToDate($scope.event.end_at),
    previous_start_at: dateTimeToDate($scope.event.start_at)
  };
  ConfirmLeaveUnsavedChangesService.watch($scope, 'frequencyUpdateParams', {
    closeModal: function() {
      return $scope.close(true);
    }
  });
  $scope.onClose = function() {
    params.cancelEdit();
    return $modalInstance.dismiss('cancel');
  };
  $scope.close = function(skipConfirmation) {
    if ($scope.displayConfirmationOnClose && !skipConfirmation) {
      if (window.confirm("Are you sure? This will abandon any unsaved changes.")) {
        return $scope.onClose();
      }
    } else {
      return $scope.onClose();
    }
  };
  $scope.onChange = function() {
    var base, base1, date, diff, new_end_at, new_start_at;
    (base = $scope.formData).new_start_at || (base.new_start_at = moment().toDate());
    (base1 = $scope.formData).new_end_at || (base1.new_end_at = moment().toDate());
    diff = moment($scope.formData.new_start_at).diff($scope.formData.previous_start_at, 'minutes');
    $scope.formData.previous_start_at = $scope.formData.new_start_at;
    if (diff) {
      $scope.formData.new_end_at = moment($scope.formData.new_end_at).add(diff, 'minutes').toDate();
    }
    date = $scope.formData.reschedule_date;
    new_start_at = $scope.formData.new_start_at;
    new_end_at = $scope.formData.new_end_at;
    return $scope.frequencyUpdateParams.change_attributes = {
      reschedule_date: date,
      new_start_at: mergeDateAndTime(date, new_start_at),
      new_end_at: mergeDateAndTime(date, new_end_at)
    };
  };
  $scope.isFormReady = function() {
    return !$scope.isLoading;
  };
  return $scope.save = function() {
    $scope.isLoading = true;
    return params.save($scope.frequencyUpdateParams).then(function() {
      return $scope.close(true);
    }, function() {
      return $scope.isLoading = false;
    });
  };
}]);
